module.exports = __webpack_public_path__ + "static/touchdown-on-the-red-planet-bc2f53c25022aaa3c36cc4340b4dce36.jpg";